import React, { useEffect, useState } from 'react'
import { useThemeContext } from '../../../Context/ThemeContext';
import { useTranslation } from 'react-i18next';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import { Box, Button, IconButton, InputAdornment, MenuItem, Select, TablePagination, TextField } from '@mui/material';
import './MembershipCards.css'
import MembershipCardModal from './MembershipCardModal';
import Card1 from '../../../assets/Cards/Card1.webp'
import Card2 from '../../../assets/Cards/Card2.webp'
import Card3 from '../../../assets/Cards/Card4.webp'
import CardGroup from '../../../Components/Common/CardGroup';
import { deleteMembershipCard, getMembershipCards, getMembershipCardsCount, getSettings } from '../../../Services/authService';
import TableComponent from './TableComponent';
import SearchIcon from "@mui/icons-material/Search";
import { DARKCOLORS, LIGHTCOLORS } from '../../../Utils/constants';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import SettingsModal from "./SettingsModal";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined"; // Import the new icon
import DeleteConfirmationPopup from '../../../Components/Common/DeleteConfirmationPopup';
import SuccessNotification from '../../../Components/Common/SuccessNotification';
import * as XLSX from "xlsx";
import { formatDate } from '../../../Components/Common/dateFormat';
import { DropDownIcon } from '../../../Components/Layouts/CustomIcons';
import LoadingAnimation from '../../../Components/Common/LoadingAnimation';
import { useLocation } from 'react-router-dom';

function MembershipCards() {
  const location = useLocation();
  const { mode } = useThemeContext();
  const { t } = useTranslation();
  const containerBackground = mode === 'dark' ? DARKCOLORS.BackgroundCard : LIGHTCOLORS.BackgroundCard
  const searchBackground = mode === 'dark' ? DARKCOLORS.GreyScale10 : LIGHTCOLORS.GreyScale10;
  const settingIconColor = mode === 'dark' ? DARKCOLORS.HeadingLightBackground : LIGHTCOLORS.HeadingLightBackground;
    const scroll1 = mode === 'light' ? LIGHTCOLORS.BodyDarkBackground : DARKCOLORS.BodyLightBackground;
    const scroll = mode === 'light' ? LIGHTCOLORS.GreyScale40 : DARKCOLORS.GreyScale40;
  const borderColor1 = mode === 'dark' ? DARKCOLORS.GreyScale40 : LIGHTCOLORS.GreyScale40;
  const dropCircle = mode === 'dark' ? DARKCOLORS.GreyScale50 : LIGHTCOLORS.GreyScale50;
  const dropIcon = mode === 'dark' ? DARKCOLORS.GreyScale80 : LIGHTCOLORS.GreyScale80;

  const [cardData, setCardData] = useState([]);

  const columns = [
    { field: "firstName", label: t("membershipCards.firstName") },
    { field: "lastName", label: t("membershipCards.lastName") },
    // { field: "company", label: t("membershipCards.company") },
    { field: "membershipCardNumber", label: t("membershipCards.members_ID") },
    { field: "email", label: t("membershipCards.email") },
    { field: "mobileNumber", label: t("membershipCards.mobileNumber"), align: "center" },
    // { field: "type", label: t("membershipCards.type") },
    { field: "returnedBowls", label: t("membershipCards.bowlsReturned"), align: "center" },
    { field: "pendingBowls", label: t("membershipCards.pendingReturns"), align: "center" },
    { field: "balance", label: t("membershipCards.balance") },
    // { field: "status", label: t("membershipCards.status") },
  ];

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [anchorEl, setAnchorEl] = useState(null); // Anchor element for the popup
  const [lowTriggerPoint, setLowTriggerPoint] = useState(25); // Default trigger point
  const [isDeletePopupOpen, setIsDeletePopupOpen] = useState(false);

  const [selectedRow, setSelectedRow] = useState(null);
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [notificationOpen, setNotificationOpen] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [deleteMessage, setDeleteMessage] = useState(false);
  const [noDataAlert, setNoDataAlert] = useState({ open: false, message: '' });

  const handleLowTriggerPointChange = (newTriggerPoint) => {
    setLowTriggerPoint(newTriggerPoint); // Update the low trigger point dynamically
  };
  const [modalOpenedByNotification, setModalOpenedByNotification] = useState(false);

  // Load settings from backend on mount
  useEffect(() => {
    getSettings()
      .then((data) => {
        if (data?.lowBalanceTrigger) {
          setLowTriggerPoint(data.lowBalanceTrigger);
        }
      })
      .catch((err) => console.error('Failed to load settings on mount:', err));
  }, []);

  useEffect(() => {
    if (location.state?.referenceId && rows.length > 0 && !modalOpenedByNotification) {
      const selectedCard = rows.find(card => card.id === location.state?.referenceId);
      if (selectedCard) {
        setSelectedCard(selectedCard);
        setIsModalOpen(true);
        setModalOpenedByNotification(true); // Prevents re-triggering
      }
    }
  }, [location.state?.referenceId, rows]);

  // Handle settings icon click to toggle the popup
  const handleTogglePopup = (event) => {
    if (anchorEl) {
      setAnchorEl(null); // Close the popup
    } else {
      setAnchorEl(event.currentTarget); // Open the popup
    }
  };

  useEffect(() => {
    const fetchCardsCount = async () => {
      const cardsCount = await getMembershipCardsCount();
      const updatedCardData = [
        { value: cardsCount.totalNafMembers || 0, label: t('membershipCards.totalNafMembers'), background: Card1 },
        // { value: cardsCount.totalBowls || 0, label: t('membershipCards.totalBowls'), background: Card2 },
        // { value: cardsCount.pendingBowls || 0, label: t('membershipCards.pendingBowls'), background: Card3 },
      ];

      setCardData(updatedCardData);
    };

    fetchCardsCount();
  }, [t]);

  // Close the popup
  const handleClosePopup = () => {
    setAnchorEl(null);
  };

  const handleOpenModal = () => {
    setSelectedCard(null)
    setIsModalOpen(true)
  };

  const handleCloseModal = () => {
    setSelectedCard(null);
    setIsModalOpen(false);
  };

  const fetchMembershipCards = async () => {
    try {
      const data = await getMembershipCards(page, rowsPerPage, searchTerm, statusFilter);
      setRows(data.content);
      setTotalRows(data.totalElements);
    } catch (error) {
      console.error(t("membershipCards.errorFetchingCards"), error);
    }
  };

  const handleChangePage = (event, newPage) => setPage(newPage);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setPage(0); // searching always shows matches from the first page
  };
  const handleStatusFilterChange = (e) => {
    setStatusFilter(e.target.value);
    setPage(0);
  };

  useEffect(() => {
    fetchMembershipCards();
  }, [page, rowsPerPage, searchTerm, statusFilter]);

  const handleEditClick = (row) => {
    setSelectedCard(row);
    setIsModalOpen(true);
  };

  const handleDeleteClick = (row) => {
    setSelectedRow(row);
    row.type === 'Membership' ? setDeleteMessage(true) : setDeleteMessage(false)
    setIsDeletePopupOpen(true);
  };

  const handleCloseDeletePopup = () => {
    setIsDeletePopupOpen(false);
    setSelectedRow(null);
  };

  const handleConfirmDelete = async () => {
    if (!selectedRow) return;

    try {
      setLoading(true)
      await deleteMembershipCard(selectedRow.id); // Call the delete API
      setSuccessMessage(t('membershipCards.deletedSuccessfully'));
      setNotificationOpen(true); // Show success notification
      await fetchMembershipCards(); // Refresh the table data
      handleCloseDeletePopup(); // Close the delete confirmation popup
    } catch (error) {
      setErrorMessage(`${t('membershipCards.Faileddeletemembership')}`);
    } finally {
      setLoading(false)
    }
  };

  const handleCloseNotification = () => {
    setNotificationOpen(false);
    setSuccessMessage('');
  };

  // Handle individual row selection
  const handleRowSelect = (row) => {
    if (selectedRows.some((selectedRow) => selectedRow.id === row.id)) {
      setSelectedRows(selectedRows.filter((selectedRow) => selectedRow.id !== row.id));
    } else {
      setSelectedRows([...selectedRows, row]);
    }
  };

  // Handle "Select All"
  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedRows([]); // Deselect all
    } else {
      setSelectedRows(rows); // Select all
    }
    setSelectAll(!selectAll);
  };

  // Handle Export to Excel — exports ALL rows matching the current
  // search/filter, regardless of the visible page
  const handleExport = async () => {
    if (!totalRows) {
      setNoDataAlert({ open: true, message: t('discounts.Nodataexport') });
      return;
    }
    try {
      setLoading(true);
      // ponytail: one oversized page fetch; if the backend ever caps `size`,
      // upgrade to looping pages
      const data = await getMembershipCards(0, totalRows, searchTerm, statusFilter);
      const exportData = data.content || [];

      if (exportData.length === 0) {
        setNoDataAlert({ open: true, message: t('discounts.Nodataexport') });
        return;
      }

      // English to German header mapping
      const headerMapping = {
        firstName: t("membershipCards.firstName", "First Name"),
        lastName: t("membershipCards.lastName", "Last Name"),
        membershipCardNumber: t("membershipCards.membershipCardNumber", "Membership Card Number"),
        mobileNumber: t("membershipCards.mobileNumber", "Mobile Number"),
        // type: t("membershipCards.type", "Type"),
        email: t("membershipCards.email", "Email"),
        // cardType: t("membershipCards.cardType", "Card Type"),
        balance: t("membershipCards.balance", "Balance"),
        returnedBowls: t("membershipCards.bowlsReturned", "Bowls Returned"),
        pendingBowls: t("membershipCards.pendingReturns", "Pending Returns"),
        startDate: t("membershipCards.startDate", "Start Date"),
        // status: t("membershipCards.status", "Status"),
        // company: t("membershipCards.company", "Company"),
        addressLine1: t("membershipCards.addressLine1", "Address Line 1"),
        addressLine2: t("membershipCards.addressLine2", "Address Line 2"),
        city: t("membershipCards.city", "City"),
        state: t("membershipCards.state", "State"),
        zipCode: t("membershipCards.zipCode", "ZIP Code"),
      };

      const translatedStatus = (status) => {
        if (status?.toLowerCase() === "active") return t("membershipCards.active");
        if (status?.toLowerCase() === "inactive") return t("membershipCards.inactive");
        return status;
      };

      const transformedData = exportData.map(row => {
        const newRow = {};
        Object.keys(headerMapping).forEach(key => {
          let value = row[key];

          if (key === "status") {
            value = translatedStatus(value);
          }
          else if (key === "startDate") {
            // Same localized format the table shows (e.g. "08 Aug 2026")
            value = formatDate(value);
          }
          else if (key === "balance") {
            value = value ? `€ ${value}` : `€ 0`;
          }
          newRow[headerMapping[key]] = value;
        });
        return newRow;
      });

      // Generate timestamp
      const timestamp = new Date().toISOString().replace(/[-:T]/g, "").slice(0, 14);

      // Create worksheet and workbook
      const worksheet = XLSX.utils.json_to_sheet(transformedData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Mitgliedskarten");

      // Save file
      const fileName = t(
  "membershipCards.export_file_name",
  "Membership_Cards"
);

XLSX.writeFile(workbook, `${fileName}_${timestamp}.xlsx`);
    } catch (error) {
      console.error(t("membershipCards.errorFetchingCards"), error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='dashboard-container-overview'>
      {loading && <LoadingAnimation />}
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <h2 className='membership-text-heading'>{t('membershipCards.customerManagement')}</h2>
        <Button className='export-sales-btn' onClick={handleOpenModal} endIcon={<AddCircleOutlineOutlinedIcon style={{ marginTop: "1px", whiteSpace: 'nowrap' }} />}>
          {t('membershipCards.newCard')}
        </Button>
      </Box>
      <Box sx={{ width: "33.3% " }}>
        <CardGroup cardData={cardData} />
      </Box>

      <Box style={{ background: containerBackground, borderRadius: "12px" }}>
        <Box className="membership-list-icon-section" sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", p: "0px 7px" }}>
          <TextField
            className='membership-search-bar'
            placeholder={t("membershipCards.searchByFields")}
            value={searchTerm}
            onChange={handleSearchChange}
            style={{ borderRadius: "24px", background: searchBackground, width: "calc(12rem + 12vw)" }}
            size="small"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ fontSize: "20px" }} />
                </InputAdornment>
              ),
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  border: "none", // Removes the border from the outline
                },
              },
            }}
          />

          <Box className='membership-btn-section' sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            {/* Settings Icon */}
            <Box className='setting-btn' sx={{ display: "flex", justifyContent: "flex-end", p: 2 }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "40px",
                  height: "40px",
                  borderRadius: "20px",
                  border: `2.5px solid ${borderColor1}`,
                  cursor: "pointer",
                }}
                onClick={handleTogglePopup}
              >
                <IconButton sx={{ p: 0 }}>
                  <SettingsOutlinedIcon style={{ fontSize: "1.5rem", color: settingIconColor }} />
                </IconButton>
              </Box>
            </Box>
            {/* Sort */}
            {/* <Box className='sort-btn' sx={{ display: "flex", gap: 2 }}>
              <Select
                value={statusFilter}
                onChange={handleStatusFilterChange}
                displayEmpty
                size="small"
                IconComponent={(props) => (
                  <DropDownIcon className='mem-sort-icon' color1={dropCircle} color2={dropIcon} {...props} />
                )} // Use the custom DropDownIcon component
                sx={{
                  borderRadius: "24px",
                  border: `0px solid ${borderColor1}`,
                  textAlign: "center",
                  paddingRight: "12px",
                  "& .MuiSelect-select": {
                    padding: "9px 20px 9px 20px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    border: `0.5px solid ${borderColor1}`,
                  },
                  '@media (max-width: 470px)': {
                    fontSize: "12px",
                  },
                }}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      borderRadius: "16px",
                      border: `0px solid ${borderColor1}`,
                      boxShadow: "none",
                      backgroundColor: containerBackground,
                      padding: "10px",
                      marginTop: "10px",
                    },
                  },
                }}
                renderValue={(selected) => {
                  if (selected === "") {
                    return (
                      <p className='sort-filter-text mem-sort'>{t("membershipCards.filter")}</p>
                    );// Show "Sort" as placeholder when no value selected
                  }
                  return selected;
                }}
              >
                <MenuItem className='menu-item-sec' value="">{t("membershipCards.all")}</MenuItem>
                <MenuItem className='menu-item-sec' value="Active">{t("membershipCards.active")}</MenuItem>
                <MenuItem className='menu-item-sec' value="Inactive">{t("membershipCards.inactive")}</MenuItem>
              </Select>
            </Box> */}
            {/* Export Btn */}
            <Button id='export-btn' className='export-sales-btn mem-export-sales-btn' style={{ fontSize: "13px", background: "transparent", color: settingIconColor, border: `0.5px solid ${borderColor1}`, padding: "9.5px 26px" }} onClick={handleExport} endIcon={<FileUploadOutlinedIcon />}>
              {t('membershipCards.export')}
            </Button>
          </Box>
        </Box>
        {loading ? (
          <p> {t('vendingMachines.Loading')}</p>
        ) : (
          <>
            <TableComponent
              rows={rows || []}
              columns={columns || []}
              onEdit={handleEditClick}
              onDelete={handleDeleteClick}
              lowTriggerPoint={lowTriggerPoint}
              onRowSelect={handleRowSelect}
              onSelectAll={handleSelectAll}
              selectedRows={selectedRows || []}
              selectAll={selectAll}
            />
            <TablePagination
              component="div"
              count={totalRows}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              labelRowsPerPage={t('membershipCards.RowsPerPage', 'Rows Per Page')}
              onRowsPerPageChange={handleChangeRowsPerPage}
              rowsPerPageOptions={[10, 25, 50, 100]}

              sx={{
                display: 'flex',
                justifyContent: 'center', // Center the pagination controls
                alignItems: 'center',
                overflowX: 'auto',
                // Same custom scrollbar as the table container
                '&::-webkit-scrollbar': {
                  width: '10px !important',
                  height: '10px !important',
                },
                '&::-webkit-scrollbar-track': {
                  backgroundColor: scroll1,
                  borderRadius: '10px',
                  border: `1px solid ${scroll}`,
                },
                '&::-webkit-scrollbar-thumb': {
                  backgroundColor: scroll,
                  borderRadius: '10px',
                  border: '3px solid transparent',
                  backgroundClip: 'padding-box',
                  '&:hover': {
                    backgroundColor: scroll,
                  },
                },
              }}
            />
          </>
        )}
      </Box>

      {/* Modal Popup */}
      <MembershipCardModal open={isModalOpen} onClose={handleCloseModal} selectedCard={selectedCard} fetchMembershipCards={fetchMembershipCards} onDelete={handleDeleteClick} />

      {/* Settings Modal */}
      <SettingsModal
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClosePopup}
        onLowTriggerPointChange={handleLowTriggerPointChange}
      />
      {/* Delete Confirmation Popup */}
      <DeleteConfirmationPopup
        open={isDeletePopupOpen}
        onClose={handleCloseDeletePopup}
        heading={deleteMessage ? t('membershipCards.deleteConfirmHeading') : t('membershipCards.deleteConfirmHeading1')}
        message={deleteMessage ? t('membershipCards.deleteConfirmMessage') : t('membershipCards.deleteConfirmMessage1')}
        onConfirm={handleConfirmDelete}
        itemName={`(${selectedRow?.id})`}
        errorMessage={errorMessage}
      />

      {/* Success Notification */}
      <SuccessNotification
        open={notificationOpen}
        message={successMessage}
        onClose={handleCloseNotification}
      />

      {/* No Data Export Alert */}
      <SuccessNotification
        open={noDataAlert.open}
        message={noDataAlert.message}
        severity="warning"
        onClose={() => setNoDataAlert({ open: false, message: '' })}
      />
    </div>
  )
}

export default MembershipCards